import React from 'react';
import { Divider } from 'antd';
import PropTypes from 'prop-types';
import { LRCopy } from 'pages/lrmanager/LRView/LRview';

// const pageInPixes = {
// 	A4: { width: 2480, height: 3508 },
// 	Legal: { width: 4200, height: 2550 },
// };

export const LRPrint = React.forwardRef((props, ref) => (
	<div ref={ref} style={{ display: props.isvisible ? '' : 'none', width: '1500px' }} {...props}>
		{['Transport', 'Sender', 'Receiver'].map((title, index) => (
			<div key={title}>
				{index === 2 &&
					(props.ispdf ? (
						<div style={{ height: '200px' }} />
					) : (
						<div style={{ pageBreakBefore: 'always' }} />
					))}
				<LRCopy key={title} title={title} details={props.details} />
				{index === 0 && <Divider dashed style={{ border: '1px dashed black' }} />}
			</div>
		))}
	</div>
));

LRPrint.propTypes = {
	details: PropTypes.object.isRequired,
	isvisible: PropTypes.number,
	ispdf: PropTypes.number,
};
